import styled from 'styled-components';
import grey from 'sushiweb/tokens/color/grey';

// Info Grid - Reusable label-value layout
export const InfoGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  ${({ indented }) => indented && `
    padding: 12px 0 12px 20px;
    border-left: 2px solid ${grey.z200};
  `}
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const InfoLabel = styled.span`
  font-size: 13px;
  font-family: 'Lexend-400';
  color: ${grey.z500};
  min-width: 160px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    opacity: 0.7;
  }
`;

export const InfoValue = styled.span`
  font-size: 13px;
  font-family: 'Lexend-500';
  color: ${grey.z900};
`;
